import { removeDuplicateQuestions } from './helper-functions';

let questions = [
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which company did Valve cooperate with in the creation of the Vive?',
    'correct_answer': 'HTC',
    'incorrect_answers': ['Oculus', 'Google', 'Razer'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the most common surname Wales?',
    'correct_answer': 'Jones',
    'incorrect_answers': ['Williams', 'Davies', 'Evans'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What was the name of the WWF professional wrestling tag team made up of the wrestlers Ax and Smash?',
    'correct_answer': 'Demolition',
    'incorrect_answers': ['The Dream Team', 'The Bushwhackers', 'The British Bulldogs'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the first book of the Old Testament?',
    'correct_answer': 'Genesis',
    'incorrect_answers': ['Exodus', 'Leviticus', 'Numbers'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'In the video-game franchise Kingdom Hearts, the main protagonist, carries a weapon with what shape?',
    'correct_answer': 'Key',
    'incorrect_answers': ['Sword', 'Pen', 'Cellphone'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'In past times, what would a gentleman keep in his fob pocket?',
    'correct_answer': 'Watch',
    'incorrect_answers': ['Money', 'Keys', 'Notebook'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Area 51 is located in which US state?',
    'correct_answer': 'Nevada',
    'incorrect_answers': ['Arizona', 'New Mexico', 'Utah'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the largest organ of the human body?',
    'correct_answer': 'Skin',
    'incorrect_answers': ['Heart', 'large Intestine', 'Liver'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does the "S" stand for in the abbreviation SIM, as in SIM card? ',
    'correct_answer': 'Subscriber',
    'incorrect_answers': ['Single', 'Secure', 'Solid'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What word represents the letter "T" in the NATO phonetic alphabet?',
    'correct_answer': 'Tango',
    'incorrect_answers': ['Target', 'Taxi', 'Turkey'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What alcoholic drink is made from molasses?',
    'correct_answer': 'Rum',
    'incorrect_answers': ['Gin', 'Vodka', 'Whisky'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which American president appears on a one dollar bill?',
    'correct_answer': 'George Washington',
    'incorrect_answers': ['Thomas Jefferson', 'Abraham Lincoln', 'Benjamin Franklin'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What geometric shape is generally used for stop signs?',
    'correct_answer': 'Octagon',
    'incorrect_answers': ['Hexagon', 'Circle', 'Triangle'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the shape of the toy invented by Hungarian professor Ernő Rubik?',
    'correct_answer': 'Cube',
    'incorrect_answers': ['Sphere', 'Cylinder', 'Pyramid'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of the Jewish New Year?',
    'correct_answer': 'Rosh Hashanah',
    'incorrect_answers': ['Elul', 'New Year', 'Succoss'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which one of the following rhythm games was made by Harmonix?',
    'correct_answer': 'Rock Band',
    'incorrect_answers': ['Meat Beat Mania', 'Guitar Hero Live', 'Dance Dance Revolution'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What type of animal was Harambe, who was shot after a child fell into it"s enclosure at the Cincinnati Zoo?',
    'correct_answer': 'Gorilla',
    'incorrect_answers': ['Tiger', 'Panda', 'Crocodile'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many colors are there in a rainbow?',
    'correct_answer': '7',
    'incorrect_answers': ['8', '9', '10'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Red Vines is a brand of what type of candy?',
    'correct_answer': 'Licorice',
    'incorrect_answers': ['Lollipop', 'Chocolate', 'Bubblegum'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the nickname of the US state of California?',
    'correct_answer': 'Golden State',
    'incorrect_answers': ['Sunshine State', 'Bay State', 'Treasure State'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is on display in the Madame Tussaud"s museum in London?',
    'correct_answer': 'Wax sculptures',
    'incorrect_answers': ['Designer clothing', 'Unreleased film reels', 'Vintage cars'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of these colours is NOT featured in the logo for Google?',
    'correct_answer': 'Pink',
    'incorrect_answers': ['Yellow', 'Blue', 'Green'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the Spanish word for "donkey"?',
    'correct_answer': 'Burro',
    'incorrect_answers': ['Caballo', 'Toro', 'Perro'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Five dollars is worth how many nickles?',
    'correct_answer': '100',
    'incorrect_answers': ['50', '25', '69'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which one of these is not a typical European sword design?',
    'correct_answer': 'Scimitar',
    'incorrect_answers': ['Falchion', 'Ulfberht', 'Flamberge'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'According to Sherlock Holmes, "If you eliminate the impossible, whatever remains, however improbable, must be the..."',
    'correct_answer': 'Truth',
    'incorrect_answers': ['Answer', 'Cause', 'Source'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What do the letters of the fast food chain KFC stand for?',
    'correct_answer': 'Kentucky Fried Chicken',
    'incorrect_answers': ['Kentucky Fresh Cheese', 'Kibbled Freaky Cow', 'Kiwi Food Cut'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How tall is the Burj Khalifa?',
    'correct_answer': '2,722 ft',
    'incorrect_answers': ['2,717 ft', '2,546 ft', '3,024 ft'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which sign of the zodiac comes between Virgo and Scorpio?',
    'correct_answer': 'Libra',
    'incorrect_answers': ['Gemini', 'Taurus', 'Capricorn'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following presidents is not on Mount Rushmore?',
    'correct_answer': 'John F. Kennedy',
    'incorrect_answers': ['Theodore Roosevelt', 'Abraham Lincoln', 'Thomas Jefferson'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What company developed the vocaloid Hatsune Miku?',
    'correct_answer': 'Crypton Future Media',
    'incorrect_answers': ['Sega', 'Sony', 'Yamaha Corporation'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which country, not including Japan, has the most people of japanese decent?',
    'correct_answer': 'Brazil',
    'incorrect_answers': ['China', 'South Korea', 'United States of America'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'In which fast food chain can you order a Jamocha Shake?',
    'correct_answer': 'Arby"s',
    'incorrect_answers': ['McDonald"s', 'Burger King', 'Wendy"s'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following is the IATA code for Manchester Airport?',
    'correct_answer': 'MAN',
    'incorrect_answers': ['EGLL', 'LHR', 'EGCC'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What nuts are used in the production of marzipan?',
    'correct_answer': 'Almonds',
    'incorrect_answers': ['Peanuts', 'Walnuts', 'Pistachios'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The likeness of which president is featured on the rare $2 bill of USA currency?',
    'correct_answer': 'Thomas Jefferson',
    'incorrect_answers': ['Martin Van Buren', 'Ulysses Grant', 'John Quincy Adams'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is Cynophobia the fear of?',
    'correct_answer': 'Dogs',
    'incorrect_answers': ['Birds', 'Flying', 'Germs'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'According to the nursery rhyme, what fruit did Little Jack Horner pull out of his Christmas pie?',
    'correct_answer': 'Plum',
    'incorrect_answers': ['Apple', 'Peach', 'Pear'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Terry Gilliam was an animator that worked with which British comedy group?',
    'correct_answer': 'Monty Python',
    'incorrect_answers': [
      'The Goodies;',
      'The League of Gentlemen;',
      'The Penny Dreadfuls',
    ],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'When someone is inexperienced they are said to be what color?',
    'correct_answer': 'Green',
    'incorrect_answers': ['Red', 'Blue', 'Yellow'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'If you are caught "Goldbricking", what are you doing wrong?',
    'correct_answer': 'Slacking',
    'incorrect_answers': ['Smoking', 'Stealing', 'Cheating'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The Flag of the European Union has how many stars on it?',
    'correct_answer': '12',
    'incorrect_answers': ['10', '14', '16'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many furlongs are there in a mile?',
    'correct_answer': 'Eight',
    'incorrect_answers': ['Two', 'Four', 'Six'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of NASA\'s most famous space telescope?',
    'correct_answer': 'Hubble Space Telescope',
    'incorrect_answers': ['Big Eye', 'Death Star', 'Millenium Falcon'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Earth is located in which galaxy?',
    'correct_answer': 'The Milky Way Galaxy',
    'incorrect_answers': ['The Mars Galaxy', 'The Galaxy Note', 'The Black Hole'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'Virgin Trains, Virgin Atlantic and Virgin Racing, are all companies owned by which famous entrepreneur?   ',
    'correct_answer': 'Richard Branson',
    'incorrect_answers': ['Alan Sugar', 'Donald Trump', 'Bill Gates'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the most common surname Wales?',
    'correct_answer': 'Jones',
    'incorrect_answers': ['Williams', 'Davies', 'Evans'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What was the name of the WWF professional wrestling tag team made up of the wrestlers Ax and Smash?',
    'correct_answer': 'Demolition',
    'incorrect_answers': ['The Dream Team', 'The Bushwhackers', 'The British Bulldogs'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the first book of the Old Testament?',
    'correct_answer': 'Genesis',
    'incorrect_answers': ['Exodus', 'Leviticus', 'Numbers'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'In the video-game franchise Kingdom Hearts, the main protagonist, carries a weapon with what shape?',
    'correct_answer': 'Key',
    'incorrect_answers': ['Sword', 'Pen', 'Cellphone'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'Which best selling toy of 1983 caused hysteria, resulting in riots breaking out in stores?',
    'correct_answer': 'Cabbage Patch Kids',
    'incorrect_answers': ['Transformers', 'Care Bears', 'Rubik\'s Cube'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does a funambulist walk on?',
    'correct_answer': 'A Tight Rope',
    'incorrect_answers': ['Broken Glass', 'Balls', 'The Moon'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Area 51 is located in which US state?',
    'correct_answer': 'Nevada',
    'incorrect_answers': ['Arizona', 'New Mexico', 'Utah'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How would one say goodbye in Spanish?',
    'correct_answer': 'Adios',
    'incorrect_answers': ['Hola', 'Au Revoir', 'Salir'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which sign of the zodiac is represented by the Crab?',
    'correct_answer': 'Cancer',
    'incorrect_answers': ['Libra', 'Virgo', 'Sagittarius'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'On a dartboard, what number is directly opposite No. 1?',
    'correct_answer': '19',
    'incorrect_answers': ['20', '12', '15'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does the "S" stand for in the abbreviation SIM, as in SIM card? ',
    'correct_answer': 'Subscriber',
    'incorrect_answers': ['Single', 'Secure', 'Solid'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What word represents the letter "T" in the NATO phonetic alphabet?',
    'correct_answer': 'Tango',
    'incorrect_answers': ['Target', 'Taxi', 'Turkey'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What alcoholic drink is made from molasses?',
    'correct_answer': 'Rum',
    'incorrect_answers': ['Gin', 'Vodka', 'Whisky'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which American president appears on a one dollar bill?',
    'correct_answer': 'George Washington',
    'incorrect_answers': ['Thomas Jefferson', 'Abraham Lincoln', 'Benjamin Franklin'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What geometric shape is generally used for stop signs?',
    'correct_answer': 'Octagon',
    'incorrect_answers': ['Hexagon', 'Circle', 'Triangle'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is "dabbing"?',
    'correct_answer': 'A dance',
    'incorrect_answers': ['A medical procedure', 'A sport', 'A language'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the shape of the toy invented by Hungarian professor Ernő Rubik?',
    'correct_answer': 'Cube',
    'incorrect_answers': ['Sphere', 'Cylinder', 'Pyramid'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of the Jewish New Year?',
    'correct_answer': 'Rosh Hashanah',
    'incorrect_answers': ['Elul', 'New Year', 'Succoss'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What type of animal was Harambe, who was shot after a child fell into it"s enclosure at the Cincinnati Zoo?',
    'correct_answer': 'Gorilla',
    'incorrect_answers': ['Tiger', 'Panda', 'Crocodile'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Red Vines is a brand of what type of candy?',
    'correct_answer': 'Licorice',
    'incorrect_answers': ['Lollipop', 'Chocolate', 'Bubblegum'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the nickname of the US state of California?',
    'correct_answer': 'Golden State',
    'incorrect_answers': ['Sunshine State', 'Bay State', 'Treasure State'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What was the nickname given to the Hughes H-4 Hercules, a heavy transport flying boat which achieved flight in 1947?',
    'correct_answer': 'Spruce Goose',
    'incorrect_answers': ['Noah"s Ark', 'Fat Man', 'Trojan Horse'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of these colours is NOT featured in the logo for Google?',
    'correct_answer': 'Pink',
    'incorrect_answers': ['Yellow', 'Blue', 'Green'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the Spanish word for "donkey"?',
    'correct_answer': 'Burro',
    'incorrect_answers': ['Caballo', 'Toro', 'Perro'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the French word for "hat"?',
    'correct_answer': 'Chapeau',
    'incorrect_answers': ['Bonnet', 'Manse', 'Casque'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Five dollars is worth how many nickles?',
    'correct_answer': '100',
    'incorrect_answers': ['50', '25', '69'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Who is depicted on the US hundred dollar bill?',
    'correct_answer': 'Benjamin Franklin',
    'incorrect_answers': ['George Washington', 'Abraham Lincoln', 'Thomas Jefferson'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What do the letters in the GMT time zone stand for?',
    'correct_answer': 'Greenwich Mean Time',
    'incorrect_answers': ['Global Meridian Time', 'General Median Time', 'Glasgow Man Time'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which American-owned brewery led the country in sales by volume in 2015?',
    'correct_answer': 'D. G. Yuengling and Son, Inc',
    'incorrect_answers': ['Anheuser Busch', 'Boston Beer Company', 'Miller Coors'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'According to Sherlock Holmes, "If you eliminate the impossible, whatever remains, however improbable, must be the..."',
    'correct_answer': 'Truth',
    'incorrect_answers': ['Answer', 'Cause', 'Source'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of Poland in Polish?',
    'correct_answer': 'Polska',
    'incorrect_answers': ['Pupcia', 'Polszka', 'Poliska'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What do the letters of the fast food chain KFC stand for?',
    'correct_answer': 'Kentucky Fried Chicken',
    'incorrect_answers': ['Kentucky Fresh Cheese', 'Kibbled Freaky Cow', 'Kiwi Food Cut'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What was the first ever London Underground line to be built?',
    'correct_answer': 'Metropolitan Line',
    'incorrect_answers': ['Circle Line', 'Bakerloo Line', 'Victoria Line'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How tall is the Burj Khalifa?',
    'correct_answer': '2,722 ft',
    'incorrect_answers': ['2,717 ft', '2,546 ft', '3,024 ft'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What machine element is located in the center of fidget spinners?',
    'correct_answer': 'Bearings',
    'incorrect_answers': ['Axles', 'Gears', 'Belts'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which sign of the zodiac comes between Virgo and Scorpio?',
    'correct_answer': 'Libra',
    'incorrect_answers': ['Gemini', 'Taurus', 'Capricorn'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is Tasmania?',
    'correct_answer': 'An Australian State',
    'incorrect_answers': [
      'A flavor of Ben and Jerry"s ice-cream',
      'A Psychological Disorder',
      'The Name of a Warner Brothers Cartoon Character',
    ],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which country, not including Japan, has the most people of japanese decent?',
    'correct_answer': 'Brazil',
    'incorrect_answers': ['China', 'South Korea', 'United States of America'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following is the IATA code for Manchester Airport?',
    'correct_answer': 'MAN',
    'incorrect_answers': ['EGLL', 'LHR', 'EGCC'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the Zodiac symbol for Gemini?',
    'correct_answer': 'Twins',
    'incorrect_answers': ['Fish', 'Scales', 'Maiden'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What zodiac sign is represented by a pair of scales?',
    'correct_answer': 'Libra',
    'incorrect_answers': ['Aries', 'Capricorn', 'Sagittarius'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The likeness of which president is featured on the rare $2 bill of USA currency?',
    'correct_answer': 'Thomas Jefferson',
    'incorrect_answers': ['Martin Van Buren', 'Ulysses Grant', 'John Quincy Adams'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'According to the nursery rhyme, what fruit did Little Jack Horner pull out of his Christmas pie?',
    'correct_answer': 'Plum',
    'incorrect_answers': ['Apple', 'Peach', 'Pear'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Terry Gilliam was an animator that worked with which British comedy group?',
    'correct_answer': 'Monty Python',
    'incorrect_answers': [
      'The Goodies;',
      'The League of Gentlemen;',
      'The Penny Dreadfuls',
    ],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'When someone is inexperienced they are said to be what color?',
    'correct_answer': 'Green',
    'incorrect_answers': ['Red', 'Blue', 'Yellow'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The Flag of the European Union has how many stars on it?',
    'correct_answer': '12',
    'incorrect_answers': ['10', '14', '16'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'When someone is cowardly, they are said to have what color belly?',
    'correct_answer': 'Yellow',
    'incorrect_answers': ['Green', 'Red', 'Blue'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the closest planet to our solar system"s sun?',
    'correct_answer': 'Mercury',
    'incorrect_answers': ['Mars', 'Jupiter', 'Earth'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'Virgin Trains, Virgin Atlantic and Virgin Racing, are all companies owned by which famous entrepreneur?   ',
    'correct_answer': 'Richard Branson',
    'incorrect_answers': ['Alan Sugar', 'Donald Trump', 'Bill Gates'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the most common surname Wales?',
    'correct_answer': 'Jones',
    'incorrect_answers': ['Williams', 'Davies', 'Evans'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the first book of the Old Testament?',
    'correct_answer': 'Genesis',
    'incorrect_answers': ['Exodus', 'Leviticus', 'Numbers'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'In the video-game franchise Kingdom Hearts, the main protagonist, carries a weapon with what shape?',
    'correct_answer': 'Key',
    'incorrect_answers': ['Sword', 'Pen', 'Cellphone'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'Which best selling toy of 1983 caused hysteria, resulting in riots breaking out in stores?',
    'correct_answer': 'Cabbage Patch Kids',
    'incorrect_answers': ['Transformers', 'Care Bears', 'Beanie Babies'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does a funambulist walk on?',
    'correct_answer': 'A Tight Rope',
    'incorrect_answers': ['Broken Glass', 'Balls', 'The Moon'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How would one say goodbye in Spanish?',
    'correct_answer': 'Adios',
    'incorrect_answers': ['Hola', 'Au Revoir', 'Salir'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the largest organ of the human body?',
    'correct_answer': 'Skin',
    'incorrect_answers': ['Heart', 'large Intestine', 'Liver'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which sign of the zodiac is represented by the Crab?',
    'correct_answer': 'Cancer',
    'incorrect_answers': ['Libra', 'Virgo', 'Sagittarius'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'On a dartboard, what number is directly opposite No. 1?',
    'correct_answer': '19',
    'incorrect_answers': ['20', '12', '15'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does the "S" stand for in the abbreviation SIM, as in SIM card? ',
    'correct_answer': 'Subscriber',
    'incorrect_answers': ['Single', 'Secure', 'Solid'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What alcoholic drink is made from molasses?',
    'correct_answer': 'Rum',
    'incorrect_answers': ['Gin', 'Vodka', 'Whisky'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What geometric shape is generally used for stop signs?',
    'correct_answer': 'Octagon',
    'incorrect_answers': ['Hexagon', 'Circle', 'Triangle'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is "dabbing"?',
    'correct_answer': 'A dance',
    'incorrect_answers': ['A medical procedure', 'A sport', 'A language'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the shape of the toy invented by Hungarian professor Ernő Rubik?',
    'correct_answer': 'Cube',
    'incorrect_answers': ['Sphere', 'Cylinder', 'Pyramid'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many colors are there in a rainbow?',
    'correct_answer': '7',
    'incorrect_answers': ['8', '9', '10'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Red Vines is a brand of what type of candy?',
    'correct_answer': 'Licorice',
    'incorrect_answers': ['Lollipop', 'Chocolate', 'Bubblegum'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the nickname of the US state of California?',
    'correct_answer': 'Golden State',
    'incorrect_answers': ['Sunshine State', 'Bay State', 'Treasure State'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What was the nickname given to the Hughes H-4 Hercules, a heavy transport flying boat which achieved flight in 1947?',
    'correct_answer': 'Spruce Goose',
    'incorrect_answers': ['Noah"s Ark', 'Fat Man', 'Trojan Horse'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of these colours is NOT featured in the logo for Google?',
    'correct_answer': 'Pink',
    'incorrect_answers': ['Yellow', 'Blue', 'Green'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the Spanish word for "donkey"?',
    'correct_answer': 'Burro',
    'incorrect_answers': ['Caballo', 'Toro', 'Perro'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Five dollars is worth how many nickles?',
    'correct_answer': '100',
    'incorrect_answers': ['50', '25', '69'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Who is depicted on the US hundred dollar bill?',
    'correct_answer': 'Benjamin Franklin',
    'incorrect_answers': ['George Washington', 'Abraham Lincoln', 'Thomas Jefferson'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What do the letters in the GMT time zone stand for?',
    'correct_answer': 'Greenwich Mean Time',
    'incorrect_answers': ['Global Meridian Time', 'General Median Time', 'Glasgow Man Time'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which one of these is not a typical European sword design?',
    'correct_answer': 'Scimitar',
    'incorrect_answers': ['Falchion', 'Ulfberht', 'Flamberge'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which American-owned brewery led the country in sales by volume in 2015?',
    'correct_answer': 'D. G. Yuengling and Son, Inc',
    'incorrect_answers': ['Anheuser Busch', 'Boston Beer Company', 'Miller Coors'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What do the letters of the fast food chain KFC stand for?',
    'correct_answer': 'Kentucky Fried Chicken',
    'incorrect_answers': ['Kentucky Fresh Cheese', 'Kibbled Freaky Cow', 'Kiwi Food Cut'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What color is the "Ex" in FedEx Ground?',
    'correct_answer': 'Green',
    'incorrect_answers': ['Red', 'Light Blue', 'Orange'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What was the first ever London Underground line to be built?',
    'correct_answer': 'Metropolitan Line',
    'incorrect_answers': ['Circle Line', 'Bakerloo Line', 'Victoria Line'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What machine element is located in the center of fidget spinners?',
    'correct_answer': 'Bearings',
    'incorrect_answers': ['Axles', 'Gears', 'Belts'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which sign of the zodiac comes between Virgo and Scorpio?',
    'correct_answer': 'Libra',
    'incorrect_answers': ['Gemini', 'Taurus', 'Capricorn'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What company developed the vocaloid Hatsune Miku?',
    'correct_answer': 'Crypton Future Media',
    'incorrect_answers': ['Sega', 'Sony', 'Yamaha Corporation'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which country, not including Japan, has the most people of japanese decent?',
    'correct_answer': 'Brazil',
    'incorrect_answers': ['China', 'South Korea', 'United States of America'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'In which fast food chain can you order a Jamocha Shake?',
    'correct_answer': 'Arby"s',
    'incorrect_answers': ['McDonald"s', 'Burger King', 'Wendy"s'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following is the IATA code for Manchester Airport?',
    'correct_answer': 'MAN',
    'incorrect_answers': ['EGLL', 'LHR', 'EGCC'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the Zodiac symbol for Gemini?',
    'correct_answer': 'Twins',
    'incorrect_answers': ['Fish', 'Scales', 'Maiden'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What zodiac sign is represented by a pair of scales?',
    'correct_answer': 'Libra',
    'incorrect_answers': ['Aries', 'Capricorn', 'Sagittarius'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What nuts are used in the production of marzipan?',
    'correct_answer': 'Almonds',
    'incorrect_answers': ['Peanuts', 'Walnuts', 'Pistachios'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The likeness of which president is featured on the rare $2 bill of USA currency?',
    'correct_answer': 'Thomas Jefferson',
    'incorrect_answers': ['Martin Van Buren', 'Ulysses Grant', 'John Quincy Adams'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'According to the nursery rhyme, what fruit did Little Jack Horner pull out of his Christmas pie?',
    'correct_answer': 'Plum',
    'incorrect_answers': ['Apple', 'Peach', 'Pear'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Terry Gilliam was an animator that worked with which British comedy group?',
    'correct_answer': 'Monty Python',
    'incorrect_answers': [
      'The Goodies;',
      'The League of Gentlemen;',
      'The Penny Dreadfuls',
    ],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'If you are caught "Goldbricking", what are you doing wrong?',
    'correct_answer': 'Slacking',
    'incorrect_answers': ['Smoking', 'Stealing', 'Cheating'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The Flag of the European Union has how many stars on it?',
    'correct_answer': '12',
    'incorrect_answers': ['10', '14', '16'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many furlongs are there in a mile?',
    'correct_answer': 'Eight',
    'incorrect_answers': ['Two', 'Four', 'Six'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'When one is "envious", they are said to be what color?',
    'correct_answer': 'Green',
    'incorrect_answers': ['Red', 'Blue', 'Yellow'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'When someone is cowardly, they are said to have what color belly?',
    'correct_answer': 'Yellow',
    'incorrect_answers': ['Green', 'Red', 'Blue'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of NASA\'s most famous space telescope?',
    'correct_answer': 'Hubble Space Telescope',
    'incorrect_answers': ['Big Eye', 'Death Star', 'Millenium Falcon'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Earth is located in which galaxy?',
    'correct_answer': 'The Milky Way Galaxy',
    'incorrect_answers': ['The Mars Galaxy', 'The Galaxy Note', 'The Black Hole'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which company did Valve cooperate with in the creation of the Vive?',
    'correct_answer': 'HTC',
    'incorrect_answers': ['Oculus', 'Google', 'Razer'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the most common surname Wales?',
    'correct_answer': 'Jones',
    'incorrect_answers': ['Williams', 'Davies', 'Evans'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What was the name of the WWF professional wrestling tag team made up of the wrestlers Ax and Smash?',
    'correct_answer': 'Demolition',
    'incorrect_answers': ['The Dream Team', 'The Bushwhackers', 'The British Bulldogs'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the first book of the Old Testament?',
    'correct_answer': 'Genesis',
    'incorrect_answers': ['Exodus', 'Leviticus', 'Numbers'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'In the video-game franchise Kingdom Hearts, the main protagonist, carries a weapon with what shape?',
    'correct_answer': 'Key',
    'incorrect_answers': ['Sword', 'Pen', 'Cellphone'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'Which best selling toy of 1983 caused hysteria, resulting in riots breaking out in stores?',
    'correct_answer': 'Cabbage Patch Kids',
    'incorrect_answers': ['Transformers', 'Care Bears', 'Rubik\'s Cube'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does a funambulist walk on?',
    'correct_answer': 'A Tight Rope',
    'incorrect_answers': ['Broken Glass', 'Balls', 'The Moon'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'In past times, what would a gentleman keep in his fob pocket?',
    'correct_answer': 'Watch',
    'incorrect_answers': ['Money', 'Keys', 'Notebook'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Area 51 is located in which US state?',
    'correct_answer': 'Nevada',
    'incorrect_answers': ['Arizona', 'New Mexico', 'Utah'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How would one say goodbye in Spanish?',
    'correct_answer': 'Adios',
    'incorrect_answers': ['Hola', 'Au Revoir', 'Salir'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the largest organ of the human body?',
    'correct_answer': 'Skin',
    'incorrect_answers': ['Heart', 'large Intestine', 'Liver'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does the "S" stand for in the abbreviation SIM, as in SIM card? ',
    'correct_answer': 'Subscriber',
    'incorrect_answers': ['Single', 'Secure', 'Solid'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What word represents the letter "T" in the NATO phonetic alphabet?',
    'correct_answer': 'Tango',
    'incorrect_answers': ['Target', 'Taxi', 'Turkey'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What geometric shape is generally used for stop signs?',
    'correct_answer': 'Octagon',
    'incorrect_answers': ['Hexagon', 'Circle', 'Triangle'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is "dabbing"?',
    'correct_answer': 'A dance',
    'incorrect_answers': ['A medical procedure', 'A sport', 'A language'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which one of the following rhythm games was made by Harmonix?',
    'correct_answer': 'Rock Band',
    'incorrect_answers': ['Meat Beat Mania', 'Guitar Hero Live', 'Dance Dance Revolution'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What type of animal was Harambe, who was shot after a child fell into it"s enclosure at the Cincinnati Zoo?',
    'correct_answer': 'Gorilla',
    'incorrect_answers': ['Tiger', 'Panda', 'Crocodile'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Red Vines is a brand of what type of candy?',
    'correct_answer': 'Licorice',
    'incorrect_answers': ['Lollipop', 'Chocolate', 'Bubblegum'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the nickname of the US state of California?',
    'correct_answer': 'Golden State',
    'incorrect_answers': ['Sunshine State', 'Bay State', 'Treasure State'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is on display in the Madame Tussaud"s museum in London?',
    'correct_answer': 'Wax sculptures',
    'incorrect_answers': ['Designer clothing', 'Unreleased film reels', 'Vintage cars'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of these colours is NOT featured in the logo for Google?',
    'correct_answer': 'Pink',
    'incorrect_answers': ['Yellow', 'Blue', 'Green'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the Spanish word for "donkey"?',
    'correct_answer': 'Burro',
    'incorrect_answers': ['Caballo', 'Toro', 'Perro'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which one of these is not a typical European sword design?',
    'correct_answer': 'Scimitar',
    'incorrect_answers': ['Falchion', 'Ulfberht', 'Flamberge'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which American-owned brewery led the country in sales by volume in 2015?',
    'correct_answer': 'D. G. Yuengling and Son, Inc',
    'incorrect_answers': ['Anheuser Busch', 'Boston Beer Company', 'Miller Coors'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'According to Sherlock Holmes, "If you eliminate the impossible, whatever remains, however improbable, must be the..."',
    'correct_answer': 'Truth',
    'incorrect_answers': ['Answer', 'Cause', 'Source'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What do the letters of the fast food chain KFC stand for?',
    'correct_answer': 'Kentucky Fried Chicken',
    'incorrect_answers': ['Kentucky Fresh Cheese', 'Kibbled Freaky Cow', 'Kiwi Food Cut'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which restaurant"s mascot is a clown?',
    'correct_answer': 'McDonald"s',
    'incorrect_answers': ['Whataburger', 'Burger King', 'Sonic'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What color is the "Ex" in FedEx Ground?',
    'correct_answer': 'Green',
    'incorrect_answers': ['Red', 'Light Blue', 'Orange'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following card games revolves around numbers and basic math?',
    'correct_answer': 'Uno',
    'incorrect_answers': ['Go Fish', 'Twister', 'Munchkin'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What machine element is located in the center of fidget spinners?',
    'correct_answer': 'Bearings',
    'incorrect_answers': ['Axles', 'Gears', 'Belts'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which sign of the zodiac comes between Virgo and Scorpio?',
    'correct_answer': 'Libra',
    'incorrect_answers': ['Gemini', 'Taurus', 'Capricorn'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following presidents is not on Mount Rushmore?',
    'correct_answer': 'John F. Kennedy',
    'incorrect_answers': ['Theodore Roosevelt', 'Abraham Lincoln', 'Thomas Jefferson'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What company developed the vocaloid Hatsune Miku?',
    'correct_answer': 'Crypton Future Media',
    'incorrect_answers': ['Sega', 'Sony', 'Yamaha Corporation'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which country, not including Japan, has the most people of japanese decent?',
    'correct_answer': 'Brazil',
    'incorrect_answers': ['China', 'South Korea', 'United States of America'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which candy is NOT made by Mars?',
    'correct_answer': 'Almond Joy',
    'incorrect_answers': ['M & M\'s', 'Twix', 'Snickers'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'In which fast food chain can you order a Jamocha Shake?',
    'correct_answer': 'Arby"s',
    'incorrect_answers': ['McDonald"s', 'Burger King', 'Wendy"s'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following is the IATA code for Manchester Airport?',
    'correct_answer': 'MAN',
    'incorrect_answers': ['EGLL', 'LHR', 'EGCC'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the Zodiac symbol for Gemini?',
    'correct_answer': 'Twins',
    'incorrect_answers': ['Fish', 'Scales', 'Maiden'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What zodiac sign is represented by a pair of scales?',
    'correct_answer': 'Libra',
    'incorrect_answers': ['Aries', 'Capricorn', 'Sagittarius'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What nuts are used in the production of marzipan?',
    'correct_answer': 'Almonds',
    'incorrect_answers': ['Peanuts', 'Walnuts', 'Pistachios'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The likeness of which president is featured on the rare $2 bill of USA currency?',
    'correct_answer': 'Thomas Jefferson',
    'incorrect_answers': ['Martin Van Buren', 'Ulysses Grant', 'John Quincy Adams'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is Cynophobia the fear of?',
    'correct_answer': 'Dogs',
    'incorrect_answers': ['Birds', 'Flying', 'Germs'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Terry Gilliam was an animator that worked with which British comedy group?',
    'correct_answer': 'Monty Python',
    'incorrect_answers': [
      'The Goodies;',
      'The League of Gentlemen;',
      'The Penny Dreadfuls',
    ],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'If you are caught "Goldbricking", what are you doing wrong?',
    'correct_answer': 'Slacking',
    'incorrect_answers': ['Smoking', 'Stealing', 'Cheating'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The Flag of the European Union has how many stars on it?',
    'correct_answer': '12',
    'incorrect_answers': ['10', '14', '16'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'When one is "envious", they are said to be what color?',
    'correct_answer': 'Green',
    'incorrect_answers': ['Red', 'Blue', 'Yellow'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of NASA\'s most famous space telescope?',
    'correct_answer': 'Hubble Space Telescope',
    'incorrect_answers': ['Big Eye', 'Death Star', 'Millenium Falcon'],
  },
  {
    'category': 'General Knowledge',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Earth is located in which galaxy?',
    'correct_answer': 'The Milky Way Galaxy',
    'incorrect_answers': ['The Mars Galaxy', 'The Galaxy Note', 'The Black Hole'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which Apollo mission was the first one to land on the Moon?',
    'correct_answer': 'Apollo 11',
    'incorrect_answers': ['Apollo 10', 'Apollo 9', 'Apollo 13'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which is the chemical name of H2O?',
    'correct_answer': 'Dihydrogen Monoxide',
    'incorrect_answers': ['Ammonium chloride', 'Anhydrous Sodium Carbonate', 'Manganese dioxide'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which is the longest bone in the human body? ',
    'correct_answer': 'Femur',
    'incorrect_answers': ['Scapula', 'Fibula', 'Ulna'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'In aeronautics, flaps and slats are used to control what on an aircraft?',
    'correct_answer': 'Lift',
    'incorrect_answers': ['Thrust', 'Drag', 'Weight '],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'This element, when overcome with extreme heat and pressure, creates diamonds.',
    'correct_answer': 'Carbon',
    'incorrect_answers': ['Nitrogen', 'Oxygen', 'Hydrogen'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the elemental symbol for mercury?',
    'correct_answer': 'Hg',
    'incorrect_answers': ['Me', 'Mc', 'Hy'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which of these stars is the largest?',
    'correct_answer': 'UY Scuti',
    'incorrect_answers': ['VY Canis Majoris', 'Betelgeuse', 'RW Cephei'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the hottest planet in the Solar System?',
    'correct_answer': 'Venus',
    'incorrect_answers': ['Mars', 'Mercury', 'Jupiter'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the first element on the periodic table?',
    'correct_answer': 'Hydrogen',
    'incorrect_answers': ['Helium', 'Oxygen', 'Lithium'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What common name is given to the medial condition, tibial stress syndrome (MTSS)?',
    'correct_answer': 'Shin Splints',
    'incorrect_answers': ['Tennis Elbow', 'Carpal Tunnel', 'Housemaid"s Knee'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'On the Beaufort Scale of wind force, what wind name is given to number 8?',
    'correct_answer': 'Gale',
    'incorrect_answers': ['Storm', 'Hurricane', 'Breeze'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which gas forms about 78% of the Earth\'s atmosphere?',
    'correct_answer': 'Nitrogen',
    'incorrect_answers': ['Oxygen', 'Argon', 'Carbon Dioxide'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'To the nearest minute, how long does it take for light to travel from the Sun to the Earth?',
    'correct_answer': '8 Minutes',
    'incorrect_answers': ['6 Minutes', '2 Minutes', '12 Minutes'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which chemical element has the lowest boiling point?',
    'correct_answer': 'Helium',
    'incorrect_answers': ['Hydrogen', 'Neon', 'Nitrogen'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the powerhouse of the cell?',
    'correct_answer': 'Mitochondria',
    'incorrect_answers': ['Ribosome', 'Redbull', 'Nucleus'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the molecular formula of Glucose?',
    'correct_answer': 'C6H12O6',
    'incorrect_answers': ['C2H4O2', 'K+', 'CH4'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the standard SI unit for temperature?',
    'correct_answer': 'Kelvin',
    'incorrect_answers': ['Fahrenheit', 'Celsius', 'Rankine'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many planets make up our Solar System?',
    'correct_answer': '8',
    'incorrect_answers': ['7', '9', '6'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of the following blood vessels carries deoxygenated blood?',
    'correct_answer': 'Pulmonary Artery',
    'incorrect_answers': ['Pulmonary Vein', 'Aorta', 'Coronary Artery'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the scientific name of the knee cap?',
    'correct_answer': 'Patella',
    'incorrect_answers': ['Femur', 'Foramen Magnum', 'Scapula'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Alzheimer"s disease primarily affects which part of the human body?',
    'correct_answer': 'Brain',
    'incorrect_answers': ['Lungs', 'Skin', 'Heart'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Who developed the first successful polio vaccine in the 1950s?',
    'correct_answer': 'Jonas Salk',
    'incorrect_answers': ['John F. Enders', 'Thomas Weller', 'Frederick Robbins'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the chemical formula for ammonia?',
    'correct_answer': 'NH3',
    'incorrect_answers': ['CO2', 'NO3', 'CH4'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the scientific name of the red fox?',
    'correct_answer': 'Vulpes Vulpes',
    'incorrect_answers': ['Vulpes Redus', 'Red Fox', 'Vulpes Vulpie'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What does DNA stand for?',
    'correct_answer': 'Deoxyribonucleic Acid',
    'incorrect_answers': ['Deoxyribogenetic Acid', 'Deoxyribogenetic Atoms', 'Detoxic Acid'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Folic acid is the synthetic form of which vitamin?',
    'correct_answer': 'Vitamin B',
    'incorrect_answers': ['Vitamin A', 'Vitamin C', 'Vitamin D'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What does the yellow diamond on the NFPA 704 fire diamond represent?',
    'correct_answer': 'Reactivity',
    'incorrect_answers': ['Health', 'Flammability', 'Radioactivity'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The element involved in making human blood red is which of the following?',
    'correct_answer': 'Iron',
    'incorrect_answers': ['Copper', 'Iridium', 'Cobalt'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'A comet"s gaseous envelope (which creates the tail) is called what?',
    'correct_answer': 'The coma',
    'incorrect_answers': ['The wake', 'The backwash', 'The ablative'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Human cells typically have how many copies of each gene?',
    'correct_answer': '2',
    'incorrect_answers': ['1', '4', '3'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which is the most abundant element in the universe?',
    'correct_answer': 'Hydrogen',
    'incorrect_answers': ['Helium', 'Lithium', 'Oxygen'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The medical term for the belly button is which of the following?',
    'correct_answer': 'Umbilicus',
    'incorrect_answers': ['Nevus', 'Nares', 'Paxillus'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these is a stop codon in DNA?',
    'correct_answer': 'TAA',
    'incorrect_answers': ['ACT', 'ACA', 'GTA'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'Which of the following plastic is commonly used for window frames, gutters and drain pipes?',
    'correct_answer': 'Polyvinylchloride (PVC) ',
    'incorrect_answers': ['Polyethylene (PE)', 'Polypropylene (PP)', 'Polystyrene (PS)'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'What stage of development do the majority of eukaryotic cells remain in for most of their life?',
    'correct_answer': 'Interphase',
    'incorrect_answers': ['Prophase', 'Stasis', 'Telophase'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many chromosomes are in your body cells?',
    'correct_answer': '23',
    'incorrect_answers': ['21', '22', '24'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the standard atomic weight of a Plutonium nucleus?',
    'correct_answer': '244',
    'incorrect_answers': ['94', '481', '128'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What nucleotide pairs with guanine?',
    'correct_answer': 'Cytosine',
    'incorrect_answers': ['Thymine', 'Adenine', 'Uracil'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What does the term "isolation" refer to in microbiology?',
    'correct_answer':
      'The separation of a strain from a natural, mixed population of living microbes',
    'incorrect_answers': [
      'A lack of nutrition in microenviroments',
      'The nitrogen level in soil',
      'Testing effects of certain microorganisms in an isolated enviroments, such as caves',
    ],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'How much radiation does a banana emit?',
    'correct_answer': '0.1 Microsievert',
    'incorrect_answers': ['0.3 Microsievert', '0.5 Microsievert', '0.7 Microsievert'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Burning which of these metals will produce a bright white flame?',
    'correct_answer': 'Magnesium',
    'incorrect_answers': ['Copper', 'Lithium', 'Lead'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of the following is NOT a word used to describe an earthquake?',
    'correct_answer': 'Drop-slide',
    'incorrect_answers': ['Foreshock', 'Strike-slip', 'Temblor'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What animal takes part in Schrodinger\'s most famous thought experiment?',
    'correct_answer': 'Cat',
    'incorrect_answers': ['Dog', 'Bat', 'Butterfly'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What are human nails made of?',
    'correct_answer': 'Keratin',
    'incorrect_answers': ['Bone', 'Chitin', 'Calcium'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the scientific name for the extinct hominin known as "Lucy"?',
    'correct_answer': 'Australopithecus Afarensis',
    'incorrect_answers': [
      'Australopithecus Africanus',
      'Australopithecus Architeuthis',
      'Australopithecus Antaris',
    ],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'Which planet did the "Viking 1" spacecraft send surface images of, starting in 1976?',
    'correct_answer': 'Mars',
    'incorrect_answers': ['Saturn', 'Jupiter', 'Venus'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Approximately how long is a year on Uranus?',
    'correct_answer': '84 Earth years',
    'incorrect_answers': ['47 Earth years', '62 Earth years', '109 Earth years'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'On the periodic table of elements, what is the symbol for Tin?',
    'correct_answer': 'Sn',
    'incorrect_answers': ['Ti', 'Ni', 'Na'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'How many protons are in an oxygen atom?',
    'correct_answer': 'Eight',
    'incorrect_answers': ['Four', 'Two', 'Six'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'What is the official name of the star located closest to the North Celestial Pole?',
    'correct_answer': 'Polaris',
    'incorrect_answers': ['Eridanus', 'Gamma Cephei', 'Iota Cephei'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What country is not a part of Scandinavia?',
    'correct_answer': 'Finland',
    'incorrect_answers': ['Norway', 'Sweden', 'Denmark'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'In which city, is the Big Nickel located in Canada?',
    'correct_answer': 'Sudbury, Ontario',
    'incorrect_answers': [
      'Calgary, Alberta',
      'Halifax, Nova Scotia ',
      'Victoria, British Columbia',
    ],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the capital of the American state of Arizona?',
    'correct_answer': 'Phoenix',
    'incorrect_answers': ['Montgomery', 'Tallahassee', 'Raleigh'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The body of the Egyptian Sphinx was based on which animal?',
    'correct_answer': 'Lion',
    'incorrect_answers': ['Bull', 'Horse', 'Dog'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Montreal is in which Canadian province?',
    'correct_answer': 'Quebec',
    'incorrect_answers': ['Ontario', 'Nova Scotia', 'Alberta'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the capital of Peru?',
    'correct_answer': 'Lima',
    'incorrect_answers': ['Santiago', 'Montevideo', 'Buenos Aires'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which of these is NOT a city in Saudi Arabia?',
    'correct_answer': 'Dubai',
    'incorrect_answers': ['Riyadh', 'Mecca', 'Medina'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these island countries is located in the Caribbean?',
    'correct_answer': 'Barbados',
    'incorrect_answers': ['Fiji', 'Maldives', 'Seychelles'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these is NOT a city in India?',
    'correct_answer': 'Islamabad',
    'incorrect_answers': ['Hyderabad', 'Ahmedabad', 'Ghaziabad'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which of these is NOT an Australian state or territory?',
    'correct_answer': 'Alberta',
    'incorrect_answers': ['New South Wales', 'Victoria', 'Queensland'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many federal states does Germany have?',
    'correct_answer': '16',
    'incorrect_answers': ['13', '32', '25'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which country is completely landlocked by South Africa?',
    'correct_answer': 'Lesotho',
    'incorrect_answers': ['Swaziland', 'Botswana', 'Zimbabwe'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'The mountainous Khyber Pass connects which of the two following countries?',
    'correct_answer': 'Afghanistan and Pakistan',
    'incorrect_answers': ['India and Nepal', 'Pakistan and India', 'Tajikistan and Kyrgyzstan'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the 15th letter of the Greek alphabet?',
    'correct_answer': 'Omicron',
    'incorrect_answers': ['Sigma', 'Pi', 'Nu'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'On which continent is the country of Angola located?',
    'correct_answer': 'Africa',
    'incorrect_answers': ['South America', 'Europe', 'Asia'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What African country has Portuguese as its official language?',
    'correct_answer': 'Mozambique',
    'incorrect_answers': ['Botswana', 'Gabon', 'Togo'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'The Japanese district Akihabara is also known by what nickname?',
    'correct_answer': 'Electric Town',
    'incorrect_answers': ['Moon Walk River', 'Otaku Central ', 'Big Eyes'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which of these is NOT an island that is part of the Philippines?',
    'correct_answer': 'Java',
    'incorrect_answers': ['Luzon', 'Mindanao', 'Palawan'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'Gibraltar, located just south of the Iberian peninsula, is a territory of which West Europe country?',
    'correct_answer': 'United Kingdom',
    'incorrect_answers': ['Spain', 'Portugal', 'France'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What event led to Liechenstein adding a crown to its flag?',
    'correct_answer': 'The 1936 Olympics',
    'incorrect_answers': [
      'Coronation of Prince Johann I Joseph in 1805',
      'Charles VI"s decree in 1719',
      'Signing of the 1862 Constitution of Liechtenstein',
    ],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Where are the Nazca Lines located?',
    'correct_answer': 'Peru',
    'incorrect_answers': ['Brazil', 'Colombia', 'Ecuador'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the capital of Senegal?',
    'correct_answer': 'Dakar',
    'incorrect_answers': ['Nouakchott', 'Conakry', 'Monrovia'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which is the largest freshwater lake in the world?',
    'correct_answer': 'Lake Superior ',
    'incorrect_answers': ['Caspian Sea', 'Lake Michigan', 'Lake Huron'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'Which of these African countries list "Spanish" as an official language?',
    'correct_answer': 'Equatorial Guinea',
    'incorrect_answers': ['Guinea', 'Cameroon', 'Angola'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the nickname for the US state Delaware?',
    'correct_answer': 'The First State',
    'incorrect_answers': ['The Fiftieth State', 'The Second State', 'The Sixteenth State'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which country was NOT formerly part of Yugoslavia?',
    'correct_answer': 'Albania',
    'incorrect_answers': ['Croatia', 'Serbia', 'Macedonia'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of the peninsula containing Spain and Portugal?',
    'correct_answer': 'Iberian Peninsula',
    'incorrect_answers': [
      'European Peninsula',
      'Peloponnesian Peninsula',
      'Scandinavian Peninsula',
    ],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'The towns of Brugelette, Arlon and Ath are located in which country?',
    'correct_answer': 'Belgium',
    'incorrect_answers': ['Andorra', 'France', 'Luxembourg'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the capital of the US State of New York?',
    'correct_answer': 'Albany',
    'incorrect_answers': ['Buffalo', 'New York', 'Rochester'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The Space Needle is located in which city?',
    'correct_answer': 'Seattle',
    'incorrect_answers': ['Los Angles', 'Toronto', 'Vancouver'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the capital of Slovakia?',
    'correct_answer': 'Bratislava',
    'incorrect_answers': ['Sofia', 'Ljubljana', 'Sarajevo'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'What North American tourist attraction is served by the "Maid of the Mist" tour company?',
    'correct_answer': 'Niagara Falls',
    'incorrect_answers': ['Whistler, British Columbia', 'Disney World', 'Yosemite National Park'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the name of rocky region that spans most of eastern Canada?',
    'correct_answer': 'Canadian Shield',
    'incorrect_answers': ['Rocky Mountains', 'Appalachian Mountains', 'Himalayas'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the capital of Spain?',
    'correct_answer': 'Madrid',
    'incorrect_answers': ['Barcelona', 'Sevilla', 'Toledo'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the capital of India?',
    'correct_answer': 'New Delhi',
    'incorrect_answers': ['Bejing', 'Montreal', 'Tithi'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these cities has a 4 degree – East longitude. ',
    'correct_answer': 'Amsterdam',
    'incorrect_answers': ['Rio de Janero', 'Toronto', 'Hong Kong'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the largest country in the world?',
    'correct_answer': 'Russia',
    'incorrect_answers': ['Canada', 'China', 'United States'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question':
      'Which of the following countries has a flag featuring a yellow lion wielding a sword on a dark red background?',
    'correct_answer': 'Sri Lanka',
    'incorrect_answers': ['Kiribati', 'Scotland', 'Bhutan'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the capital of Mauritius?',
    'correct_answer': 'Port Louis',
    'incorrect_answers': ['Port Moresby', 'Port Vila', 'Port-au-Prince'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which ocean borders the west coast of the United States?',
    'correct_answer': 'Pacific',
    'incorrect_answers': ['Atlantic', 'Indian', 'Arctic'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'What is the most common climbing route for the second highest mountain in the world, K2?',
    'correct_answer': 'Abruzzi Spur',
    'incorrect_answers': ['Magic Line', 'Cesen Route', 'Polish Line'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which country was NOT part of the Soviet Union?',
    'correct_answer': 'Romania',
    'incorrect_answers': ['Turkmenistan', 'Belarus', 'Tajikistan'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'How many countries share a land border with Luxembourg?',
    'correct_answer': '3',
    'incorrect_answers': ['4', '2', '5'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Into which basin does the Jordan River flow into?',
    'correct_answer': 'Dead Sea',
    'incorrect_answers': ['Aral Sea', 'Caspian Sea', 'Salton Sea'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'The Maluku islands (informally known as the Spice Islands) belong to which country?',
    'correct_answer': 'Indonesia',
    'incorrect_answers': ['Chile', 'New Zealand', 'Fiji'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these cities is NOT in England?',
    'correct_answer': 'Edinburgh',
    'incorrect_answers': ['Oxford', 'Manchester', 'Southampton'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which country is the Taedong River in?',
    'correct_answer': 'North Korea',
    'incorrect_answers': ['South Korea', 'Japan', 'China'],
  },
  {
    'category': 'Geography',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'How many time zones are in Russia?',
    'correct_answer': '11',
    'incorrect_answers': ['8', '5', '2'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'What was the name of the Ethiopian Wolf before they knew it was related to wolves?',
    'correct_answer': 'Simien Jackel',
    'incorrect_answers': ['Ethiopian Coyote', 'Amharic Fox', 'Canis Simiensis'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What does "hippopotamus" mean and in what langauge?',
    'correct_answer': 'River Horse (Greek)',
    'incorrect_answers': ['River Horse (Latin)', 'Fat Pig (Greek)', 'Fat Pig (Latin)'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'A carnivorous animal eats flesh, what does a nucivorous animal eat?',
    'correct_answer': 'Nuts',
    'incorrect_answers': ['Nothing', 'Fruit', 'Seaweed'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What type of animal is a natterjack?',
    'correct_answer': 'Toad',
    'incorrect_answers': ['Bird', 'Fish', 'Insect'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the fastest  land animal?',
    'correct_answer': 'Cheetah',
    'incorrect_answers': ['Lion', 'Thomson\'s Gazelle', 'Pronghorn Antelope'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the scientific name for modern day humans?',
    'correct_answer': 'Homo Sapiens',
    'incorrect_answers': ['Homo Ergaster', 'Homo Erectus', 'Homo Neanderthalensis'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The Kākāpō is a large, flightless, nocturnal parrot native to which country?',
    'correct_answer': 'New Zealand',
    'incorrect_answers': ['South Africa', 'Australia', 'Madagascar'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which species of Brown Bear is not extinct?',
    'correct_answer': 'Syrian Brown Bear',
    'incorrect_answers': ['California Grizzly Bear', 'Atlas Bear', 'Mexican Grizzly Bear'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What color/colour is a polar bear"s skin?',
    'correct_answer': 'Black',
    'incorrect_answers': ['White', 'Pink', 'Green'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Hippocampus is the Latin name for which marine creature?',
    'correct_answer': 'Seahorse',
    'incorrect_answers': ['Dolphin', 'Whale', 'Octopus'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Cashmere is the wool from which kind of animal?',
    'correct_answer': 'Goat',
    'incorrect_answers': ['Sheep', 'Camel', 'Llama'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the scientific name for the "Polar Bear"?',
    'correct_answer': 'Ursus Maritimus',
    'incorrect_answers': ['Polar Bear', 'Ursus Spelaeus', 'Ursus Arctos'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What are rhino"s horn made of?',
    'correct_answer': 'Keratin',
    'incorrect_answers': ['Bone', 'Ivory', 'Skin'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many legs do butterflies have?',
    'correct_answer': '6',
    'incorrect_answers': ['2', '4', '0'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What scientific suborder does the family Hyaenidae belong to?',
    'correct_answer': 'Feliformia',
    'incorrect_answers': ['Haplorhini', 'Caniformia', 'Ciconiiformes'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'How many known living species of hyenas are there?',
    'correct_answer': '4',
    'incorrect_answers': ['8', '2', '6'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What scientific family does the Aardwolf belong to?',
    'correct_answer': 'Hyaenidae',
    'incorrect_answers': ['Canidae', 'Felidae', 'Eupleridae'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'For what reason would a spotted hyena "laugh"?',
    'correct_answer': 'Nervousness',
    'incorrect_answers': ['Excitement', 'Aggression', 'Exhaustion'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What do you call a baby bat?',
    'correct_answer': 'Pup',
    'incorrect_answers': ['Cub', 'Chick', 'Kid'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the scientific name of the cheetah?',
    'correct_answer': 'Acinonyx jubatus',
    'incorrect_answers': ['Panthera onca', 'Lynx rufus', 'Felis catus'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the scientific name of the Budgerigar?',
    'correct_answer': 'Melopsittacus undulatus',
    'incorrect_answers': ['Nymphicus hollandicus', 'Pyrrhura molinae', 'Ara macao'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which animal was part of an Russian domestication experiment in 1959?',
    'correct_answer': 'Foxes',
    'incorrect_answers': ['Pigeons', 'Bears', 'Alligators'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'The now extinct species "Thylacine" was native to where?',
    'correct_answer': 'Tasmania, Australia',
    'incorrect_answers': ['Baluchistan, Pakistan', 'Wallachia, Romania', 'Oregon, United States'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the Gray Wolf"s scientific name?',
    'correct_answer': 'Canis Lupus',
    'incorrect_answers': ['Canis Aureus', 'Canis Latrans', 'Canis Lupus Lycaon'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these animals is NOT a lizard?',
    'correct_answer': 'Tuatara',
    'incorrect_answers': ['Komodo Dragon', 'Gila Monster', 'Green Iguana'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is Grumpy Cat"s real name?',
    'correct_answer': 'Tardar Sauce',
    'incorrect_answers': ['Sauce', 'Minnie', 'Broccoli'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What type of creature is a Bonobo?',
    'correct_answer': 'Ape',
    'incorrect_answers': ['Lion', 'Parrot', 'Wildcat'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which of these species is not extinct?',
    'correct_answer': 'Komodo dragon',
    'incorrect_answers': ['Japanese sea lion', 'Tasmanian tiger', 'Saudi gazelle'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which class of animals are newts members of?',
    'correct_answer': 'Amphibian',
    'incorrect_answers': ['Fish', 'Reptiles', 'Mammals'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Unlike on most salamanders, this part of a newt is flat?',
    'correct_answer': 'Tail',
    'incorrect_answers': ['Head', 'Teeth', 'Feet'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the name of the family that the domestic cat is a member of?',
    'correct_answer': 'Felidae',
    'incorrect_answers': ['Felinae', 'Felis', 'Cat'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'What dog bread is one of the oldest breeds of dog and has flourished since before 400 BCE.',
    'correct_answer': 'Pugs',
    'incorrect_answers': ['Bulldogs', 'Boxers', 'Chihuahua'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'What is the name of the copper-rich protein that creates the blue blood in the Antarctic octopus?',
    'correct_answer': 'Hemocyanin',
    'incorrect_answers': ['Cytochrome', 'Iron', 'Methionine'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which species is a "mountain chicken"?',
    'correct_answer': 'Frog',
    'incorrect_answers': ['Chicken', 'Horse', 'Fly'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the fastest animal?',
    'correct_answer': 'Peregrine Falcon',
    'incorrect_answers': ['Golden Eagle', 'Cheetah', 'Horsefly'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'The dish Fugu, is made from what family of fish?',
    'correct_answer': 'Pufferfish',
    'incorrect_answers': ['Bass', 'Salmon', 'Mackerel'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the collective noun for a group of crows?',
    'correct_answer': 'Murder',
    'incorrect_answers': ['Pack', 'Gaggle', 'Herd'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'Which of the following is another name for the "Poecilotheria Metallica Tarantula"?',
    'correct_answer': 'Gooty',
    'incorrect_answers': ['Hopper', 'Silver Stripe', 'Woebegone'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the scientific name of the Common Chimpanzee?',
    'correct_answer': 'Pan troglodytes',
    'incorrect_answers': ['Gorilla gorilla', 'Pan paniscus', 'Panthera leo'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'By definition, where does an abyssopelagic animal live?',
    'correct_answer': 'At the bottom of the ocean',
    'incorrect_answers': ['In the desert', 'On top of a mountain', 'Inside a tree'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these is a colony of polyps and not a jellyfish?',
    'correct_answer': 'Portuguese Man-of-War',
    'incorrect_answers': ['Sea Wasp', 'Irukandji', 'Sea Nettle'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What colour is the female blackbird?',
    'correct_answer': 'Brown',
    'incorrect_answers': ['Black', 'White', 'Yellow'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the common term for bovine spongiform encephalopathy (BSE)?',
    'correct_answer': 'Mad Cow disease',
    'incorrect_answers': ['Weil"s disease', 'Milk fever', 'Foot-and-mouth disease'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'How many teeth does an adult rabbit have?',
    'correct_answer': '28',
    'incorrect_answers': ['30', '26', '24'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the name for a male bee that comes from an unfertilized egg?',
    'correct_answer': 'Drone',
    'incorrect_answers': ['Soldier', 'Worker', 'Male'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the name of a rabbit"s abode?',
    'correct_answer': 'Burrow',
    'incorrect_answers': ['Nest', 'Den', 'Dray'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the collective noun for bears?',
    'correct_answer': 'Sloth',
    'incorrect_answers': ['Drove', 'Tribe', 'Husk'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the collective noun for rats?',
    'correct_answer': 'Mischief',
    'incorrect_answers': ['Pack', 'Race', 'Drift'],
  },
  {
    'category': 'Animals',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the collective noun for vultures?',
    'correct_answer': 'Wake',
    'incorrect_answers': ['Ambush', 'Building', 'Gaze'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the largest animal currently on Earth?',
    'correct_answer': 'Blue Whale',
    'incorrect_answers': ['Orca', 'Colossal Squid', 'Giraffe'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which element has the chemical symbol "Fe"?',
    'correct_answer': 'Iron',
    'incorrect_answers': ['Gold', 'Silver', 'Tin'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'The moons, Miranda, Ariel, Umbriel, Titania and Oberon orbit which planet?',
    'correct_answer': 'Uranus',
    'incorrect_answers': ['Jupiter', 'Venus', 'Neptune'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'In aeronautics, flaps and slats are used to control what on an aircraft?',
    'correct_answer': 'Lift',
    'incorrect_answers': ['Thrust', 'Drag', 'Weight '],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which type of rock is created by intense heat AND pressure?',
    'correct_answer': 'Metamorphic',
    'incorrect_answers': ['Sedimentary', 'Igneous', 'Diamond'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the elemental symbol for mercury?',
    'correct_answer': 'Hg',
    'incorrect_answers': ['Me', 'Mc', 'Hy'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'What is the first element on the periodic table?',
    'correct_answer': 'Hydrogen',
    'incorrect_answers': ['Helium', 'Oxygen', 'Lithium'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What common name is given to the medial condition, tibial stress syndrome (MTSS)?',
    'correct_answer': 'Shin Splints',
    'incorrect_answers': ['Tennis Elbow', 'Carpal Tunnel', 'Housemaid"s Knee'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What mineral has the lowest number on the Mohs scale?',
    'correct_answer': 'Talc',
    'incorrect_answers': ['Quartz', 'Diamond', 'Gypsum'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which gas forms about 78% of the Earth\'s atmosphere?',
    'correct_answer': 'Nitrogen',
    'incorrect_answers': ['Oxygen', 'Argon', 'Carbon Dioxide'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'To the nearest minute, how long does it take for light to travel from the Sun to the Earth?',
    'correct_answer': '8 Minutes',
    'incorrect_answers': ['6 Minutes', '2 Minutes', '12 Minutes'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which chemical element has the lowest boiling point?',
    'correct_answer': 'Helium',
    'incorrect_answers': ['Hydrogen', 'Neon', 'Nitrogen'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'An organic compound is considered an alcohol if it has what functional group?',
    'correct_answer': 'Hydroxyl',
    'incorrect_answers': ['Carbonyl', 'Alkyl', 'Aldehyde'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which element has the atomic number of 7?',
    'correct_answer': 'Nitrogen',
    'incorrect_answers': ['Oxygen', 'Hydrogen', 'Neon'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which horizon in a soil profile consists of bedrock?',
    'correct_answer': 'R',
    'incorrect_answers': ['O', 'B', 'D'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'The "Tibia" is found in which part of the body?',
    'correct_answer': 'Leg',
    'incorrect_answers': ['Arm', 'Hand', 'Head'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Who developed the first successful polio vaccine in the 1950s?',
    'correct_answer': 'Jonas Salk',
    'incorrect_answers': ['John F. Enders', 'Thomas Weller', 'Frederick Robbins'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the chemical formula for ammonia?',
    'correct_answer': 'NH3',
    'incorrect_answers': ['CO2', 'NO3', 'CH4'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which of these chemical compounds is NOT found in gastric acid?',
    'correct_answer': 'Sulfuric acid',
    'incorrect_answers': ['Hydrochloric acid', 'Potassium chloride', 'Sodium chloride'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Which is not a type of neuron?',
    'correct_answer': 'Perceptual Neuron',
    'incorrect_answers': ['Sensory Neuron', 'Motor Neuron', 'Interneuron'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'The medical condition osteoporosis affects which part of the body?',
    'correct_answer': 'Bones',
    'incorrect_answers': ['Skin', 'Brain', 'Heart'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Folic acid is the synthetic form of which vitamin?',
    'correct_answer': 'Vitamin B',
    'incorrect_answers': ['Vitamin A', 'Vitamin C', 'Vitamin D'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the atomic number of the element Strontium?',
    'correct_answer': '38',
    'incorrect_answers': ['73', '47', '11'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which of these is NOT a part of the structure of a typical neuron?',
    'correct_answer': 'Islets of Langerhans',
    'incorrect_answers': ['Node of Ranvier', 'Schwann cell', 'Myelin sheath'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which part of the body does glaucoma affect?',
    'correct_answer': 'Eyes',
    'incorrect_answers': ['Throat', 'Stomach', 'Blood'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'The asteroid belt is located between which two planets?',
    'correct_answer': 'Mars and Jupiter',
    'incorrect_answers': ['Jupiter and Saturn', 'Mercury and Venus', 'Earth and Mars'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'A comet"s gaseous envelope (which creates the tail) is called what?',
    'correct_answer': 'The coma',
    'incorrect_answers': ['The wake', 'The backwash', 'The ablative'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which is the most abundant element in the universe?',
    'correct_answer': 'Hydrogen',
    'incorrect_answers': ['Helium', 'Lithium', 'Oxygen'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which element has the highest melting point?',
    'correct_answer': 'Carbon',
    'incorrect_answers': ['Tungsten', 'Platinum', 'Osmium'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'At what temperature does water boil?',
    'correct_answer': '212 degrees (F)',
    'incorrect_answers': ['200 degrees (F)', '181 degrees (F)', '178 degrees (F)'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Who made the discovery of X-rays?',
    'correct_answer': 'Wilhelm Conrad Roentgen',
    'incorrect_answers': ['Thomas Alva Edison', 'James Watt', 'Albert Einstein'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What genetic disease is caused by having an extra Y chromosome (XYY)?',
    'correct_answer': 'Jacob"s Syndrome',
    'incorrect_answers': ['Klinefelter"s Syndrome', 'Turner"s Syndrome', 'Down Syndrome'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the same in Celsius and Fahrenheit?',
    'correct_answer': '-40',
    'incorrect_answers': ['32', '-39', '-42'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'Botanically speaking, which of these fruits is NOT a berry?',
    'correct_answer': 'Strawberry',
    'incorrect_answers': ['Blueberry', 'Banana', 'Concord Grape'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the unit of electrical capacitance?',
    'correct_answer': 'Farad',
    'incorrect_answers': ['Gauss', 'Henry', 'Watt'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the unit of electrical inductance?',
    'correct_answer': 'Henry',
    'incorrect_answers': ['Weber', 'Coulomb', 'Mho'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'Which desert is the only desert in the world where the "Saguaro" cactus grows indigenously?',
    'correct_answer': 'The Sonoran Desert',
    'incorrect_answers': ['The Gobi Desert', 'The Yuma Desert', 'The Arabian Desert'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'In Psychology, which need appears highest in the "Maslow"s hierarchy of needs" pyramid?',
    'correct_answer': 'Esteem',
    'incorrect_answers': ['Love', 'Safety', 'Physiological'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the largest living organism currently known to man?',
    'correct_answer': 'Honey Fungus',
    'incorrect_answers': ['Blue Whale', 'Redwood Tree', 'The Coral Reef'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'On which mission did the Space Shuttle Columbia break up upon re-entry?',
    'correct_answer': 'STS-107',
    'incorrect_answers': ['STS-51-L', 'STS-61-C', 'STS-109'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question': 'What is the scientific name for the extinct hominin known as "Lucy"?',
    'correct_answer': 'Australopithecus Afarensis',
    'incorrect_answers': [
      'Australopithecus Africanus',
      'Australopithecus Architeuthis',
      'Australopithecus Antaris',
    ],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'Which of the following men does not have a chemical element named after him?',
    'correct_answer': 'Sir Isaac Newton',
    'incorrect_answers': ['Albert Einstein', 'Niels Bohr', 'Enrico Fermi'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the half-life of Uranium-235?',
    'correct_answer': '703,800,000 years',
    'incorrect_answers': [
      '4,300,400,000 years',
      '1,260,900,000 years',
      'Uranium-235 is a stable isotope',
    ],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'What is the scientific term for "taste"?',
    'correct_answer': 'Gustatory Perception',
    'incorrect_answers': ['Olfaction', 'Somatosensation', 'Auditory Perception'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question': 'On the periodic table of elements, what is the symbol for Tin?',
    'correct_answer': 'Sn',
    'incorrect_answers': ['Ti', 'Ni', 'Na'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'easy',
    'question': 'Which noble gas has the lowest atomic number?',
    'correct_answer': 'Helium',
    'incorrect_answers': ['Neon', 'Argon', 'Krypton'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'medium',
    'question':
      'An organism described as "heliotropic" has a tendancy to move towards which of these things?',
    'correct_answer': 'Light',
    'incorrect_answers': ['Water', 'Trees', 'Pollen'],
  },
  {
    'category': 'Science',
    'type': 'multiple',
    'difficulty': 'hard',
    'question':
      'Autosomal-dominant Compelling Helio-Ophthalmic Outburst syndrome is the need to do what when seeing the Sun?',
    'correct_answer': 'Sneeze',
    'incorrect_answers': ['Cough', 'Yawn', 'Hiccup'],
  },
];

questions = removeDuplicateQuestions(questions);
export default questions;